type EventType = Record<string, (...args: any[]) => void>;

export default class EventBus<T extends EventType> {
  private _events: Map<keyof T, T[keyof T][]> = new Map();

  on<K extends keyof T>(eventName: K, callback: T[K]) {
    const callbacks = this._events.get(eventName) || [];
    callbacks.push(callback);
    this._events.set(eventName, callbacks);

    return () => {
      this.off(eventName, callback);
    };
  }

  emit<K extends keyof T>(eventName: K, ...args: Parameters<T[K]>) {
    const callbacks = this._events.get(eventName) || [];
    callbacks.forEach((callback) => callback(...args));
  }

  // TODO: 目前callback都是同步函数，如果有callback是异步，需要修改
  emitSync<K extends keyof T>(eventName: K, ...args: Parameters<T[K]>) {
    this.emit(eventName, ...args);
  }

  off<K extends keyof T>(eventName: K, callback: T[K]) {
    const callbacks = this._events.get(eventName) || [];
    this._events.set(
      eventName,
      callbacks.filter((cb) => cb !== callback)
    );
  }

  once<K extends keyof T>(eventName: K, callback: T[K]) {
    const wrapper = (...args: Parameters<T[K]>) => {
      callback(...args);
      this.off(eventName, wrapper as T[K]);
    };
    this.on(eventName, wrapper as T[K]);
  }
}
